import * as React from 'react';


export interface IStatChartProps {
    header?: string,
    description?: string,
    stats: {
        title: string,
        label: string,
        percent: number
    }[]
}

function StatChart({ header, description, stats }: IStatChartProps) {
    return <div className="stat-chart">
        <header>
            <h4>{header}</h4>
            <p>{description}</p>
        </header>
        <div className="stat-grid">
            {stats.map((stat, i) => <div key={i} className="stat-wrapper">
                <div className="cell">
                    <div className="stat-title">{stat.title}</div>
                </div>
                <div className="cell info">
                    <div></div>
                </div>
                <div className="cell bar-cell">
                    <div className="bar-wrapper">
                        <div className="bar-percent">{stat.label ? stat.label : 'NOT ENOUGH DATA'}</div>
                        <div className="bar" style={{ width: `${stat.percent}%` }}></div>
                    </div>
                </div>
            </div>)}
        </div>
    </div>
}

export default StatChart;